























import Component from 'vue-class-component';
import headerProfileComponent from '@/components/TheHeaderProfile.vue';
import notificationComponent from '@/components/TheNotificationComponent.vue';
import SidebarRight from '@/components/TheSidebarRight.vue';
import { formatData } from '@/constants/commonContent';
import { Base } from '@/base';
import { requestStripe } from '@/constants/sidebarData';

const DATE_FORMAT = formatData.dateTime;

@Component({
  name: 'HeaderComponent',
  components: {
    headerProfileComponent,
    notificationComponent,
    SidebarRight
  }
})
export default class HeaderComponent extends Base {
  currentTime = null;
  formatData = formatData;

  mounted() {
    setInterval(() => {
      this.getTime();
    }, 1000);
  }

  // Methods
  getTime() {
    this.currentTime = this.$moment(Date.now()).format(DATE_FORMAT.replace('hh:mm', 'hh:mm:ss'));
  }
  paymentForm() {
    this.setSideBarForm(requestStripe());
    this.openClose();
  }
};
